/**
 * The name of a person of the import (first and last name), or their email when the file has no
 * name. Used to tell apart the buttons of each row for screen readers.
 *
 * @param {{ first_name?: string, last_name?: string, email?: string }} person
 */
export const personDisplayName = (person) =>
  `${person.first_name ?? ''} ${person.last_name ?? ''}`.trim() || person.email || '';
